// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const App = __t.object("App", {
  appId: __t.string(),
  displayName: __t.string(),
  description: __t.string(),
  get platform() {
    return AppPlatform;
  },
  get appType() {
    return AppType;
  },
  get distributionMode() {
    return DistributionMode;
  },
  executablePath: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  createdBy: __t.identity(),
  orgId: __t.string(),
});
export type App = __Infer<typeof App>;

export const AppChannelConfig = __t.object("AppChannelConfig", {
  id: __t.u64(),
  appChannelKey: __t.string(),
  appId: __t.string(),
  get channel() {
    return ReleaseChannel;
  },
  launchArgs: __t.option(__t.string()),
  displayName: __t.option(__t.string()),
  updatedAt: __t.timestamp(),
  updatedBy: __t.identity(),
  autoUpdate: __t.bool(),
});
export type AppChannelConfig = __Infer<typeof AppChannelConfig>;

export const AppLaunchOptions = __t.object("AppLaunchOptions", {
  id: __t.u64(),
  userIdentity: __t.identity(),
  appId: __t.string(),
  launchArgs: __t.string(),
  updatedAt: __t.timestamp(),
});
export type AppLaunchOptions = __Infer<typeof AppLaunchOptions>;

export const AppMaintainerOrg = __t.object("AppMaintainerOrg", {
  appId: __t.string(),
  orgId: __t.string(),
});
export type AppMaintainerOrg = __Infer<typeof AppMaintainerOrg>;

export const AppNotification = __t.object("AppNotification", {
  notificationId: __t.u64(),
  userIdentity: __t.identity(),
  get notificationType() {
    return NotificationType;
  },
  title: __t.string(),
  message: __t.string(),
  createdAt: __t.timestamp(),
  dismissed: __t.bool(),
});
export type AppNotification = __Infer<typeof AppNotification>;

// The tagged union or sum type for the algebraic type `AppPlatform`.
export const AppPlatform = __t.enum("AppPlatform", {
  Windows: __t.unit(),
  Linux: __t.unit(),
  MacOs: __t.unit(),
});
export type AppPlatform = __Infer<typeof AppPlatform>;

export const AppStatus = __t.object("AppStatus", {
  userIdentity: __t.identity(),
  version: __t.string(),
  platform: __t.string(),
  appsFolder: __t.string(),
  lastHeartbeat: __t.timestamp(),
  online: __t.bool(),
  statusMessage: __t.option(__t.string()),
});
export type AppStatus = __Infer<typeof AppStatus>;

// The tagged union or sum type for the algebraic type `AppType`.
export const AppType = __t.enum("AppType", {
  Ue5: __t.unit(),
  DotNet: __t.unit(),
  Standalone: __t.unit(),
});
export type AppType = __Infer<typeof AppType>;

export const AppVersion = __t.object("AppVersion", {
  versionId: __t.u64(),
  appId: __t.string(),
  version: __t.string(),
  get channel() {
    return ReleaseChannel;
  },
  get status() {
    return VersionStatus;
  },
  releaseNotes: __t.string(),
  totalSizeBytes: __t.u64(),
  fileCount: __t.u32(),
  createdAt: __t.timestamp(),
  publishedAt: __t.option(__t.timestamp()),
  uploadedBy: __t.identity(),
});
export type AppVersion = __Infer<typeof AppVersion>;

export const ChannelVersion = __t.object("ChannelVersion", {
  id: __t.u64(),
  appChannelKey: __t.string(),
  appId: __t.string(),
  get channel() {
    return ReleaseChannel;
  },
  currentVersionId: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type ChannelVersion = __Infer<typeof ChannelVersion>;

export const ChunkHashIndex = __t.object("ChunkHashIndex", {
  hash: __t.string(),
});
export type ChunkHashIndex = __Infer<typeof ChunkHashIndex>;

export const ChunkStore = __t.object("ChunkStore", {
  hash: __t.string(),
  sizeBytes: __t.u32(),
  referenceCount: __t.u32(),
});
export type ChunkStore = __Infer<typeof ChunkStore>;

// The tagged union or sum type for the algebraic type `ClientType`.
export const ClientType = __t.enum("ClientType", {
  Unknown: __t.unit(),
  Webclient: __t.unit(),
  App: __t.unit(),
});
export type ClientType = __Infer<typeof ClientType>;

// The tagged union or sum type for the algebraic type `CommandStatus`.
export const CommandStatus = __t.enum("CommandStatus", {
  Pending: __t.unit(),
  Running: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type CommandStatus = __Infer<typeof CommandStatus>;

// The tagged union or sum type for the algebraic type `CommandType`.
export const CommandType = __t.enum("CommandType", {
  Download: __t.unit(),
  Upload: __t.unit(),
  Launch: __t.unit(),
  Uninstall: __t.unit(),
  Sync: __t.unit(),
  OpenFolder: __t.unit(),
  Verify: __t.unit(),
});
export type CommandType = __Infer<typeof CommandType>;

export const ConnectedClient = __t.object("ConnectedClient", {
  connectionId: __t.connectionId(),
  userIdentity: __t.identity(),
  get clientType() {
    return ClientType;
  },
  connectedAt: __t.timestamp(),
});
export type ConnectedClient = __Infer<typeof ConnectedClient>;

// The tagged union or sum type for the algebraic type `DistributionMode`.
export const DistributionMode = __t.enum("DistributionMode", {
  Monolithic: __t.unit(),
});
export type DistributionMode = __Infer<typeof DistributionMode>;

export const DownloadProgress = __t.object("DownloadProgress", {
  progressId: __t.u64(),
  userIdentity: __t.identity(),
  versionId: __t.u64(),
  get status() {
    return DownloadStatus;
  },
  bytesDownloaded: __t.u64(),
  totalBytes: __t.u64(),
  startedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  completedAt: __t.option(__t.timestamp()),
  errorMessage: __t.option(__t.string()),
  statusMessage: __t.option(__t.string()),
  appId: __t.option(__t.string()),
});
export type DownloadProgress = __Infer<typeof DownloadProgress>;

export const DownloadStartedEvent = __t.object("DownloadStartedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  progressId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type DownloadStartedEvent = __Infer<typeof DownloadStartedEvent>;

// The tagged union or sum type for the algebraic type `DownloadStatus`.
export const DownloadStatus = __t.enum("DownloadStatus", {
  NotStarted: __t.unit(),
  InProgress: __t.unit(),
  Paused: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type DownloadStatus = __Infer<typeof DownloadStatus>;

// The tagged union or sum type for the algebraic type `FileCategory`.
export const FileCategory = __t.enum("FileCategory", {
  Executable: __t.unit(),
  EngineBinary: __t.unit(),
  ContentPak: __t.unit(),
  Config: __t.unit(),
  Plugin: __t.unit(),
  Other: __t.unit(),
});
export type FileCategory = __Infer<typeof FileCategory>;

export const FileChunkRef = __t.object("FileChunkRef", {
  refId: __t.u64(),
  fileId: __t.u64(),
  chunkIndex: __t.u32(),
  chunkHash: __t.string(),
});
export type FileChunkRef = __Infer<typeof FileChunkRef>;

export const FileRegisteredEvent = __t.object("FileRegisteredEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  fileId: __t.u64(),
  relativePath: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type FileRegisteredEvent = __Infer<typeof FileRegisteredEvent>;

export const InstalledVersion = __t.object("InstalledVersion", {
  id: __t.u64(),
  userIdentity: __t.identity(),
  appId: __t.string(),
  versionId: __t.u64(),
  installPath: __t.string(),
  installedAt: __t.timestamp(),
});
export type InstalledVersion = __Infer<typeof InstalledVersion>;

export const LauncherBrokerConfig = __t.object("LauncherBrokerConfig", {
  id: __t.u32(),
  brokerUrl: __t.string(),
  serviceToken: __t.string(),
  stdbHost: __t.string(),
  configuredBy: __t.identity(),
  configuredAt: __t.timestamp(),
});
export type LauncherBrokerConfig = __Infer<typeof LauncherBrokerConfig>;

// The tagged union or sum type for the algebraic type `LauncherRole`.
export const LauncherRole = __t.enum("LauncherRole", {
  NoRole: __t.unit(),
  User: __t.unit(),
  Admin: __t.unit(),
  PlatformAdmin: __t.unit(),
  Uploader: __t.unit(),
});
export type LauncherRole = __Infer<typeof LauncherRole>;

export const LauncherRoleOrg = __t.object("LauncherRoleOrg", {
  identity: __t.identity(),
  orgId: __t.string(),
});
export type LauncherRoleOrg = __Infer<typeof LauncherRoleOrg>;

export const LauncherUser = __t.object("LauncherUser", {
  identity: __t.identity(),
  username: __t.option(__t.string()),
  get role() {
    return LauncherRole;
  },
  createdAt: __t.timestamp(),
  lastConnectedAt: __t.timestamp(),
  isConnected: __t.bool(),
  orgId: __t.string(),
});
export type LauncherUser = __Infer<typeof LauncherUser>;

export const ModuleConfig = __t.object("ModuleConfig", {
  id: __t.u64(),
  platformAdminOrgId: __t.string(),
  setBy: __t.identity(),
  setAt: __t.timestamp(),
});
export type ModuleConfig = __Infer<typeof ModuleConfig>;

// The tagged union or sum type for the algebraic type `ModuleRole`.
export const ModuleRole = __t.enum("ModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type ModuleRole = __Infer<typeof ModuleRole>;

export const ModuleServiceConfig = __t.object("ModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type ModuleServiceConfig = __Infer<typeof ModuleServiceConfig>;

export const ModuleUser = __t.object("ModuleUser", {
  identity: __t.identity(),
  get role() {
    return ModuleRole;
  },
});
export type ModuleUser = __Infer<typeof ModuleUser>;

// The tagged union or sum type for the algebraic type `NotificationType`.
export const NotificationType = __t.enum("NotificationType", {
  Info: __t.unit(),
  Success: __t.unit(),
  Warning: __t.unit(),
  Error: __t.unit(),
});
export type NotificationType = __Infer<typeof NotificationType>;

export const OrgCorsOrigin = __t.object("OrgCorsOrigin", {
  id: __t.u32(),
  orgOriginKey: __t.string(),
  orgId: __t.string(),
  origin: __t.string(),
  addedBy: __t.identity(),
  addedAt: __t.timestamp(),
});
export type OrgCorsOrigin = __Infer<typeof OrgCorsOrigin>;

export const PostRestoreMarker = __t.object("PostRestoreMarker", {
  id: __t.u32(),
  ranAt: __t.timestamp(),
  ranBy: __t.identity(),
});
export type PostRestoreMarker = __Infer<typeof PostRestoreMarker>;

export const ProgressGcSchedule = __t.object("ProgressGcSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type ProgressGcSchedule = __Infer<typeof ProgressGcSchedule>;

export const ProjectAppChannelPin = __t.object("ProjectAppChannelPin", {
  id: __t.u64(),
  pinKey: __t.string(),
  orgId: __t.string(),
  project: __t.string(),
  appId: __t.string(),
  get channel() {
    return ReleaseChannel;
  },
  pinnedVersionId: __t.option(__t.u64()),
  autoUpdate: __t.option(__t.bool()),
  updatedAt: __t.timestamp(),
  updatedBy: __t.identity(),
});
export type ProjectAppChannelPin = __Infer<typeof ProjectAppChannelPin>;

export const ProjectScopeConfig = __t.object("ProjectScopeConfig", {
  id: __t.u32(),
  projectName: __t.string(),
  configuredAt: __t.timestamp(),
  allowedScopes: __t.option(__t.array(__t.string())),
});
export type ProjectScopeConfig = __Infer<typeof ProjectScopeConfig>;

export const ProjectTenantConfig = __t.object("ProjectTenantConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  isPublic: __t.bool(),
  configuredAt: __t.timestamp(),
});
export type ProjectTenantConfig = __Infer<typeof ProjectTenantConfig>;

// The tagged union or sum type for the algebraic type `ReleaseChannel`.
export const ReleaseChannel = __t.enum("ReleaseChannel", {
  Dev: __t.unit(),
  Testing: __t.unit(),
  Stable: __t.unit(),
});
export type ReleaseChannel = __Infer<typeof ReleaseChannel>;

export const UploadCompletedEvent = __t.object("UploadCompletedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  confirmed: __t.u32(),
  failed: __t.u32(),
  total: __t.u32(),
  createdAt: __t.timestamp(),
});
export type UploadCompletedEvent = __Infer<typeof UploadCompletedEvent>;

export const UploadProgress = __t.object("UploadProgress", {
  progressId: __t.u64(),
  userIdentity: __t.identity(),
  commandId: __t.u64(),
  appId: __t.string(),
  versionId: __t.u64(),
  get status() {
    return UploadStatus;
  },
  totalFiles: __t.u32(),
  filesRegistered: __t.u32(),
  totalChunks: __t.u32(),
  chunksUploaded: __t.u32(),
  totalBytes: __t.u64(),
  bytesUploaded: __t.u64(),
  currentFile: __t.option(__t.string()),
  startedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type UploadProgress = __Infer<typeof UploadProgress>;

export const UploadProgressCreatedEvent = __t.object("UploadProgressCreatedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  progressId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type UploadProgressCreatedEvent = __Infer<typeof UploadProgressCreatedEvent>;

// The tagged union or sum type for the algebraic type `UploadStatus`.
export const UploadStatus = __t.enum("UploadStatus", {
  Scanning: __t.unit(),
  Registering: __t.unit(),
  Uploading: __t.unit(),
  Finalizing: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type UploadStatus = __Infer<typeof UploadStatus>;

export const UserCommand = __t.object("UserCommand", {
  commandId: __t.u64(),
  userIdentity: __t.identity(),
  get commandType() {
    return CommandType;
  },
  get status() {
    return CommandStatus;
  },
  appId: __t.string(),
  versionId: __t.option(__t.u64()),
  exePath: __t.option(__t.string()),
  installPath: __t.option(__t.string()),
  channel: __t.option(__t.string()),
  notes: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  startedAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  errorMessage: __t.option(__t.string()),
  pakPublishConfig: __t.option(__t.string()),
  allowUnsigned: __t.bool(),
  reuseRefusedFolder: __t.bool(),
});
export type UserCommand = __Infer<typeof UserCommand>;

export const VersionCreatedEvent = __t.object("VersionCreatedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  versionId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type VersionCreatedEvent = __Infer<typeof VersionCreatedEvent>;

export const VersionFile = __t.object("VersionFile", {
  fileId: __t.u64(),
  versionId: __t.u64(),
  relativePath: __t.string(),
  get category() {
    return FileCategory;
  },
  sizeBytes: __t.u64(),
  hash: __t.string(),
  chunkCount: __t.u32(),
});
export type VersionFile = __Infer<typeof VersionFile>;

// The tagged union or sum type for the algebraic type `VersionStatus`.
export const VersionStatus = __t.enum("VersionStatus", {
  Draft: __t.unit(),
  Published: __t.unit(),
});
export type VersionStatus = __Infer<typeof VersionStatus>;

